import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import {
  FadeUpD0,
  FadeUpD1,
  HeroParent,
  HeroChildren,
  FadeRightD0,
  FadeLeftD0,
} from './animation/variants';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '20px',
    },
  },
  leftRoomsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
  },
  leftSideRooms: {
    width: '530px',
    height: '640px',
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  rightRoomsWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: 'auto',
  },
  rightSideRooms: {
    marginRight: '-130px',
    width: '530px',
    height: '640px',
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  mainTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  mainTitle: {
    color: theme.palette.secondary.main,
    marginTop: '15px',
    marginBottom: '0',
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 36,
    },
  },
  subtitle: {
    fontSize: '28px',
    color: theme.palette.secondary.light,
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  date: {
    marginTop: '20px',
    marginBottom: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  updateText: {
    fontWeight: 500,
    marginBottom: '10px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  arrowDown: {
    marginLeft: '5px',
    transform: 'rotate(90deg)',
  },
  mobileRooms: {
    marginTop: '20px',
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    },
  },
  applyNowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '5px',
  },
  applyNow: {
    borderRadius: '4px',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
    },
    [theme.breakpoints.up('md')]: {
      width: '415px',
    },
    backgroundColor: '#129F23',
    '&:hover': {
      backgroundColor: '#129F29',
    },
  },
  applyNowText: {
    color: '#FFFFFF',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'none',
    fontSize: '18px',
  },
  sponsorButton: {
    fontSize: 18,
    lineHeight: '23px',
    borderRadius: '4px',
    textAlign: 'center',
    textTransform: 'none',
    letterSpacing: '-0.04rem',
  },
}));

const RoomWrapper = styled.div`
  & > img {
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

const MainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  & > img {
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

const BodyOne = ({ actions }) => {
  const classes = useStyles();
  return (
    <Container fluid className={classes.root}>
      <Row>
        <Col xs={0} sm={1} md={1} lg={2} xl={2}>
          <RoomWrapper className={classes.leftRoomsWrapper}>
            <motion.img
              variants={FadeRightD0}
              initial="initial"
              animate="enter"
              src={require('./assets/rooms/fullRoomOne.png')}
              alt="LeftSideRooms"
              className={classes.leftSideRooms}
            />
          </RoomWrapper>
        </Col>
        <Col>
          <motion.div variants={HeroParent} initial="initial" animate="enter">
            <MainTitleWrapper>
              <img
                src={require('./assets/hw-logo.png')}
                alt="hwLogo"
                style={{ height: '144px' }}
                className={classes.hwLogo}
              />
              <motion.div
                variants={HeroChildren}
                className={classes.mainTitleWrapper}>
                <Typography variant="h1" className={classes.mainTitle}>
                  Hack Western 7
                </Typography>
                <b className={classes.subtitle}>make anything, anywhere.</b>
              </motion.div>

              <motion.div variants={HeroChildren}>
                <Typography variant="body1" className={classes.date}>
                  Virtual Hackathon - November 20-22, 2020
                </Typography>
              </motion.div>

              {/*
              <motion.div
                variants={HeroChildren}
                className={classes.applyNowWrapper}>
                <Button
                  variant="contained"
                  className={classes.applyNow}
                  href="/dashboard">
                  <Typography variant="h4" className={classes.applyNowText}>
                    Apply Now
                  </Typography>
                </Button>
              </motion.div>
              <motion.img
                variants={FadeUpD0}
                initial="initial"
                animate="enter"
                src={require('./assets/rooms/mobileRooms.png')}
                alt="MobileRooms"
                className={classes.mobileRooms}
              /> */}
            </MainTitleWrapper>
          </motion.div>
        </Col>
        <Col xs={0} sm={1} md={1} lg={2} xl={2}>
          <RoomWrapper className={classes.rightRoomsWrapper}>
            <motion.img
              variants={FadeLeftD0}
              initial="initial"
              animate="enter"
              src={require('./assets/rooms/fullRoomTwo.png')}
              alt="RightSideRooms"
              className={classes.rightSideRooms}
            />
          </RoomWrapper>
        </Col>
      </Row>
    </Container>
  );
};

export default BodyOne;
